<template><div><h1 id="adressqualitat-statistik" tabindex="-1"><a class="header-anchor" href="#adressqualitat-statistik"><span>Adressqualität-Statistik</span></a></h1>
<p>Adressqualität — Listet Refusés in Relation zu den Initalereignissen aus</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Statistik zeigt das Verhältnis von Refusés in Bezug zu den Initalereignissen. Ausgewertet werden nur Adressen mit Ereignistyp IM im angegebenen Zeitraum. Die Refusés beziehen sich auf die entsprechenden Initialereignisse. Es werden nur Refusés mit der Kategorie U, G und T berücksichtigt.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Adressqualität-Statistik (Unicef Indikatoren)</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>Datum</dt>
<dd>Datumsbereich für die Auswertung.</dd>
<dt>Ausgabe</dt>
<dd>Standard</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Auswertungsdatum von</td>
<td>Datumsbereich von</td>
</tr>
<tr>
<td>Auswertungsdatum bis</td>
<td>Datumsbereich bis</td>
</tr>
<tr>
<td>Anzahl Adressen mit Initial</td>
<td>Anzahl Adressen mit Initialereignis (Ereignistyp IM).</td>
</tr>
<tr>
<td>Anzahl Adressen mit Refusés</td>
<td>Anzahl Adressen mit Refusé in der Kategorie U, G und T.</td>
</tr>
<tr>
<td>Anzahl Adressen mit Refusés in %</td>
<td>Wie oben, jedoch in %.</td>
</tr>
</tbody>
</table>
</div></template>


